import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { Link } from "react-router-dom";
import { Building2, ArrowUpRight } from "lucide-react";
import { Ring } from "@/components/Primitives";

export default function Clients() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/clients").then(r => setItems(asArray(r.data))).catch(() => setItems([])); }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Clients</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Customer Portfolio</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map(c => (
          <Link key={c.id} to={`/clients/${c.id}`} data-testid={`client-card-${c.id}`} className="bg-zinc-950 border border-zinc-900 rounded-md p-5 hover:border-zinc-800 transition-colors group">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2"><Building2 size={14} className="text-blue-400" /><div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{c.industry}</div></div>
                <h2 className="font-display text-xl font-semibold tracking-tight mt-1">{c.name}</h2>
                <div className="text-xs text-zinc-500 mt-0.5">{c.country} · Tier {c.tier}</div>
              </div>
              <ArrowUpRight size={14} className="text-zinc-700 group-hover:text-zinc-300" />
            </div>
            <div className="mt-4 flex items-center justify-between">
              <Ring value={c.health_score} label="Health" size={64} />
              <div className="text-right space-y-1">
                <div className="text-xs text-zinc-500">Sites <span className="font-mono text-zinc-200 ml-2">{c.site_count}</span></div>
                <div className="text-xs text-zinc-500">Contact <span className="font-mono text-zinc-200 ml-2">{c.primary_contact_name}</span></div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
